var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.738 511.738",
    style: {
      enableBackground: "new 0 0 511.738 511.738"
    },
    xmlSpace: "preserve",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.749,475.591l-22.976-22.976l-36.907-36.843l59.499-59.499c8.325-8.338,8.314-21.845-0.024-30.17   c-2.197-2.193-4.846-3.881-7.763-4.945L306.24,251.741c-22.161-8.01-46.619,3.462-54.629,25.623   c-3.385,9.366-3.387,19.622-0.006,28.99l69.611,191.339c2.484,6.85,8.292,11.958,15.403,13.547   c1.521,0.331,3.073,0.495,4.629,0.491c5.658-0.001,11.083-2.25,15.083-6.251l59.435-59.605l36.843,36.843l22.976,22.976   c8.475,8.185,21.98,7.95,30.165-0.525c7.984-8.267,7.984-21.373,0-29.641L505.749,475.591z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.333,426.674C95.513,426.674,0,331.161,0,213.341S95.513,0.007,213.333,0.007S426.667,95.52,426.667,213.341   c0,11.782-9.551,21.333-21.333,21.333S384,225.123,384,213.341c0-94.257-76.41-170.667-170.667-170.667   S42.667,119.084,42.667,213.341s76.41,170.667,170.667,170.667c11.782,0,21.333,9.551,21.333,21.333   S225.115,426.674,213.333,426.674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.459,333.234c-2.804,0.002-5.58-0.549-8.171-1.621C99.003,304.497,68.06,229.592,95.175,164.306   s102.021-96.228,167.306-69.113c31.335,13.015,56.221,37.939,69.188,69.294c4.689,10.809-0.272,23.372-11.08,28.061   c-10.809,4.689-23.372-0.272-28.061-11.08c-0.098-0.226-0.192-0.453-0.282-0.682c-18.06-43.531-67.989-64.179-111.519-46.119   s-64.179,67.989-46.119,111.519c8.649,20.847,25.205,37.419,46.044,46.088c10.887,4.505,16.06,16.983,11.554,27.87   c-3.305,7.987-11.103,13.19-19.746,13.176L172.459,333.234z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/Activate.85ee36df4fbe6d0f683e20c4d3fe08d9.svg";
export { ForwardRef as ReactComponent };